import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { UserInfoIdSchema } from '../user/user.types.js';
// ===== ID SCHEMAS =====
const ExerciseComplexIdSchema = createIdSchema('exerciseComplex');
const ExerciseComplexTableSelectSchema = createStrictSchema()({
    id: ExerciseComplexIdSchema,
    name: z.string(),
    description: z.string().nullable(),
    system: z.boolean(),
    userId: UserInfoIdSchema.nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== POPULATED SCHEMAS =====
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const ExerciseComplexInfoSchema = ExerciseComplexTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(),
});
const ExerciseComplexInfoIdSchema = ExerciseComplexIdSchema;
export { ExerciseComplexInfoSchema, ExerciseComplexInfoIdSchema };
//# sourceMappingURL=exercise-complex.types.js.map